import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { RequireAuth, RequireRole } from './components/RequireAuth';
import { LoginPage } from './features/auth/LoginPage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { WeighingsListPage } from './features/weighings/WeighingsListPage';
import { WeighingFormPage } from './features/weighings/WeighingFormPage';
import { OcrCapturePage } from './features/ocr/OcrCapturePage';
import { CalendarPage } from './features/calendar/CalendarPage';
import { ContainerDumpsListPage } from './features/container-dumps/ContainerDumpsListPage';
import { VehicleLogPage } from './features/vehicle-log/VehicleLogPage';
import { ProfilePage } from './features/profile/ProfilePage';
import { UsersPage } from './features/admin/UsersPage';
import { MasterDataPage } from './features/admin/MasterDataPage';
import { EventsPage } from './features/admin/EventsPage';
import { NotFoundPage } from './features/misc/NotFoundPage';
import { FullPageSpinner } from './components/ui/Spinner';

// Code-Splitting für die beiden schwersten Abhängigkeiten (Recharts für die
// Statistik, exceljs/PDF-nahe Report-Ansicht) - werden erst geladen, wenn die
// jeweilige Seite tatsächlich besucht wird, statt den initialen Bundle
// (Login/Dashboard) unnötig aufzublähen.
const StatisticsPage = lazy(() => import('./features/statistics/StatisticsPage').then((m) => ({ default: m.StatisticsPage })));
const ReportsPage = lazy(() => import('./features/reports/ReportsPage').then((m) => ({ default: m.ReportsPage })));

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="weighings" element={<WeighingsListPage />} />
          <Route path="statistics" element={<Suspense fallback={<FullPageSpinner />}><StatisticsPage /></Suspense>} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="container-dumps" element={<ContainerDumpsListPage />} />
          <Route path="vehicle-log" element={<VehicleLogPage />} />
          <Route path="reports" element={<Suspense fallback={<FullPageSpinner />}><ReportsPage /></Suspense>} />
          <Route path="profile" element={<ProfilePage />} />

          <Route element={<RequireRole roles={['ADMIN', 'OPERATOR']} />}>
            <Route path="weighings/new" element={<WeighingFormPage mode="create" />} />
            <Route path="weighings/:id/edit" element={<WeighingFormPage mode="edit" />} />
            <Route path="ocr" element={<OcrCapturePage />} />
          </Route>

          <Route element={<RequireRole roles={['ADMIN']} />}>
            <Route path="admin/users" element={<UsersPage />} />
            <Route path="admin/master-data" element={<MasterDataPage />} />
            <Route path="admin/events" element={<EventsPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
